import { render, staticRenderFns } from "./phone2.vue?vue&type=template&id=0c5dfad6&scoped=true"
import script from "./phone2.vue?vue&type=script&lang=js"
export * from "./phone2.vue?vue&type=script&lang=js"
import style0 from "./phone2.vue?vue&type=style&index=0&id=0c5dfad6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5dfad6",
  null
  
)

export default component.exports